import { throttle } from 'lodash';

// var $ = require("jquery");
// require("jquery/package.json");

import { isMobile } from './functions.js';

var $ = require('jquery');
require('jquery/package.json');

function menu_toggle() {
	const menu_toggle = document.querySelector('.menu-toggle');

	if (!menu_toggle) return;

	const html = document.querySelectorAll('html');
	const body = document.querySelectorAll('body');
	const mobileMenu = document.getElementById('primary-menu');
	const allElementsExceptMenu = document.querySelectorAll(
		'a:not(.site-header a)'
	);

	menu_toggle.addEventListener('click', (e) => {
		e.preventDefault();

		var value = menu_toggle.getAttribute('aria-expanded');
		var aria = value === 'true' ? 'false' : 'true';
		menu_toggle.setAttribute('aria-expanded', aria);

		var tabIndex = mobileMenu.getAttribute('tabindex');
		var ariaTab = tabIndex === '1' ? '0' : '1';
		mobileMenu.setAttribute('tabindex', ariaTab);

		body[0].classList.toggle('toggled');
		menu_toggle.classList.toggle('toggled');
		html[0].classList.toggle('lock-scroll');

		menu_toggle.blur();

		// Set tab indices for all elements except the menu based on menu state
		allElementsExceptMenu.forEach((element) => {
			element.tabIndex = aria === 'true' ? '-1' : '0';
		});

		// focus the first item in the menu when opening.
		if (aria === 'true') {
			setTimeout(() => {
				const firstFocusableElement = mobileMenu.querySelector(
					'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
				);
				if (firstFocusableElement) {
					console.log(firstFocusableElement);
					firstFocusableElement.focus();
				}
			}, 100);
		}
	});
}
// window.addEventListener('DOMContentLoaded', menu_toggle);
menu_toggle();

var lastScrollTop = 0;
function header_check() {
	const header = document.querySelector('.site-header');
	if (!header) return;
	var scroll = window.pageYOffset,
		content = 1,
		st = scroll;
	if (scroll >= content) {
		header.classList.add('active');
	}
	if (st > lastScrollTop) {
		// downscroll code
		if (scroll >= content) {
			header.classList.add('active');
		} else {
			header.classList.remove('active');
		}
	} else {
		// upscroll code
		if (scroll >= content) {
			header.classList.add('active');
		} else {
			header.classList.remove('active');
		}
	}
	lastScrollTop = st;
}
window.addEventListener('load', header_check);
document.addEventListener('scroll', header_check);

function menuDropdown() {
	// const menuItems = document.querySelectorAll('.menu-item-has-children');
	const menuItems = document.querySelectorAll('#primary-menu > .menu-item');

	if (isMobile()) {
		menuItems.forEach((el) => {
			const dropdownMenu = el.querySelector('.dropdown-menu');
			const arrow = el.querySelector('.arrow');

			if (dropdownMenu) {
				// Get height of dropdowns before loaded then set value to 0 for proper display
				dropdownMenu.style.maxHeight = 'none';
				var boundingRect = dropdownMenu.getBoundingClientRect();
				var height = boundingRect.height;
				dropdownMenu.style.maxHeight = '0';

				// open dropdown menu on click + transforms
				arrow.addEventListener('click', (e) => {
					e.preventDefault();

					// reset height, aria, and remove 'active' class from all <ul>
					menuItems.forEach((item) => {
						const otherDropdownMenu = item.querySelector('ul');
						if (otherDropdownMenu) {
							if (otherDropdownMenu !== dropdownMenu) {
								otherDropdownMenu.style.maxHeight = '0px';
								otherDropdownMenu.setAttribute('aria-sub-expanded', 'false');
								item.classList.remove('active');
							}
						}
					});

					var value = dropdownMenu.getAttribute('aria-sub-expanded');
					var aria = value === 'true' ? 'false' : 'true';
					const ul = el.querySelector('ul');

					el.classList.add('active');

					dropdownMenu.setAttribute('aria-sub-expanded', aria);

					if (value === 'false') {
						dropdownMenu.style.maxHeight = height + 'px';

						// Focus on the first link when the dropdown is opened
						const firstLink = el.querySelector('ul a');
						if (firstLink) {
							firstLink.focus();
						}
					} else {
						dropdownMenu.style.maxHeight = '0px';
					}
				});
			}
		});
	}

	const siteHeader = document.querySelector('.site-header');
	const siteNavigation = document.querySelector('#site-navigation');
	if (!isMobile()) {
		// Function to remove 'active' class from all menu items
		function removeActiveClass() {
			menuItems.forEach((item) => {
				item.classList.remove('active');
			});
		}

		// Event listener for mouseenter and mouseleave on menu items
		menuItems.forEach((item) => {
			const menuItemLink = item.querySelector('a');

			if (!isMobile()) {
				menuItemLink.addEventListener('mouseenter', () => {
					removeActiveClass(); // Remove 'active' class from all other items
					item.classList.add('active'); // Add 'active' class to the current item
				});

				siteHeader.addEventListener('mouseleave', () => {
					item.classList.remove('active'); // Remove 'active' class from the current item
				});
			}

			menuItemLink.addEventListener('click', (event) => {
				event.stopPropagation(); // Prevent the click on the link from triggering the click outside handler
			});
		});

		// Event listener for clicks outside of .menu-item-has-children
		document.addEventListener('click', (event) => {
			const menuItems = document.querySelectorAll('.menu-item-has-children');

			const isClickInsideMenuItem = Array.from(menuItems).some((item) =>
				item.contains(event.target)
			);
			if (!isClickInsideMenuItem) {
				removeActiveClass();

				if (isMobile()) {
					menuItems.forEach((item) => {
						const dropdownMenu = item.querySelector('.dropdown-menu');
						const otherDropdownMenu = item.querySelector('ul');

						otherDropdownMenu.style.maxHeight = '0px';
						otherDropdownMenu.setAttribute('aria-sub-expanded', 'false');
						item.classList.remove('active');
					});
				}
			}
		});
	}
}
document.addEventListener('resize', menuDropdown);
// document.addEventListener('DOMContentLoaded', menuDropdown);
menuDropdown();

function test() {
	// Your code here
	const nav = document.querySelector('.primary-navigation');

	if (!nav) return;

	const documentWidth = document.documentElement.clientWidth;
	let padding = (nav.offsetWidth - documentWidth) / 2;

	console.log(nav.offsetWidth);
	console.log(documentWidth);
	console.log(padding);

	const dropdowns = document.querySelectorAll('.dropdown-menu');
	dropdowns.forEach((el, i) => {
		el.style.paddingLeft = padding + 'px';
		el.style.paddingRight = padding + 'px';
	});
}
document.addEventListener('DOMContentLoaded', test);

// Smooth scroll
// Handle anchor links
var anchorLinks = document.querySelectorAll('a[href*="#"]');
for (var i = 0; i < anchorLinks.length; i++) {
	var link = anchorLinks[i];
	if (link.getAttribute('href') !== '#' && link.getAttribute('href') !== '#0') {
		link.addEventListener('click', function (event) {
			// On-page links
			if (
				location.pathname.replace(/^\//, '') ==
					this.pathname.replace(/^\//, '') &&
				location.hostname == this.hostname
			) {
				// Figure out element to scroll to
				var target = document.querySelector(this.hash);
				target = target
					? target
					: document.querySelector('[name=' + this.hash.slice(1) + ']');
				// Does a scroll target exist?
				if (target) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					var scrollTop =
						target.getBoundingClientRect().top + window.pageYOffset - 150;
					var duration = 1000;
					var easing = function (t) {
						return t * (2 - t);
					};
					var start = window.pageYOffset;
					var time = 0;
					var animateScroll = function () {
						time += 16;
						var elapsed = time / duration;
						elapsed = elapsed > 1 ? 1 : elapsed;
						var eased = easing(elapsed);
						var newScrollTop = start + (scrollTop - start) * eased;
						window.scrollTo(0, newScrollTop);
						if (time < duration) {
							window.requestAnimationFrame(animateScroll);
						} else {
							// Callback after animation
							// Must change focus!
							var $target = $(target);
							$target.focus();
							if ($target.is(':focus')) {
								// Checking if the target was focused
								return false;
							} else {
								$target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
								$target.focus(); // Set focus again
							}
						}
					};
					animateScroll();
				}
			}
		});
	}
}
